// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "flowbite/dist/flowbite.turbo.js";
import "./controllers";

import "./scripts/theme";
import "./scripts/selects";
import "./scripts/date_pickers";
